// AUTH
export const API_SET_UP_USER = 'auth/setup-user';

// USER
export const API_GET_USER_DETAILS = 'user-profile/user-details';
export const API_UPDATE_CURRENTLY_WORKING_BRAND_ID =
    'user-profile/update-currently-working-brandId';
export const API_MARK_USER_OLD = 'user-profile/mark-user-old';

// Apprentice
export const API_APPRENTICE_GENERATE_AD = '/apprentice/generate_ad';
export const API_APPRENTICE_GENERATE_CAMPAIGN = '/apprentice/generate_campaign';
export const API_APPRENTICE_REMOVE_BACKGROUND = '/apprentice/remove_background';

// Brand Magic
export const API_DEFAULT_POTIONS = '/pixii-potions/potions/for-brand';
export const API_BRAND_IMAGE_GET_BRAND_FAVOURITES = '/brand-magic/image';
export const API_BRAND_MAGIC_VOICE = 'brand-magic/brand-voice';
export const API_BRAND_MAGIC_FETCH_COPY_INFO = 'brand-magic/potion/fetch-copy-information';
export const API_BRAND_MAGIC_GET_BRAND_ELEMENTS = '/brand-magic/brand-elements';
export const API_BRAND_MAGIC_ADD_COLOR = '/brand-magic/brand-elements/add-color';
export const API_BRAND_MAGIC_ADD_COLORS = '/brand-magic/brand-elements/add-colors';
export const API_BRAND_MAGIC_REMOVE_COLOR = '/brand-magic/brand-elements/remove-color';
export const API_BRAND_MAGIC_ADD_FONT = '/brand-magic/brand-elements/add-font';
export const API_BRAND_MAGIC_REMOVE_FONT = '/brand-magic/brand-elements/remove-font';
export const API_BRAND_MAGIC_ADD_LOGO = '/brand-magic/brand-elements/add-logo';
export const API_BRAND_MAGIC_REMOVE_LOGO = '/brand-magic/brand-elements/remove-logo';
export const API_BRAND_MAGIC_SCRAPING_URL = '/onboarding';

// Campaign ads
export const API_APPRENTICE_GET_CAMPAIGN_ADS = '/campaign-ads';
export const API_CAMPAIGN_ADS__ADD_VERSION = 'campaign-ads/add-version';
export const API_CAMPAIGN_ADS_DOWNLOAD_CSV = 'campaign-ads/download_csv';
export const API_UPDATE_CAPTIONS = 'campaign-ads/update-caption';

// Chat Flow
export const API_APPRENTICE_GET_CHATS = '/chat';
export const API_GET_TEMPLATE_JSON = '/chat/get_template_json';
export const API_APPRENTICE_SET_ACTIVE_TEMPLATE = '/chat/set_active_template';
export const API_APPRENTICE_NEW_TEMPLATE_FROM_EDITOR = '/chat/new_template_from_editor';

// Campaign Flow
export const API_APPRENTICE_WRITE_CAMPAIGN = '/campaign/write';
export const API_APPRENTICE_CREATE_CAMPAIGN = '/campaign/create_campaign';
export const API_APPRENTICE_DELETE_CAMPAIGN = '/campaign/delete_campaign';
export const API_APPRENTICE_UPDATE_CAMPAIGN = '/campaign/update_campaign';
export const API_APPRENTICE_GET_BRAND_CAMPAIGNs = '/campaign/get_brand_campaigns';
export const API_NEW_USER_CAMPAIGN = '/campaign/get_new_user_campaign';
export const API_APPRENTICE_GET_SNAPSHOT_CAMPAIGNS = '/campaign/get_snapshot_campaign';
export const API_APPRENTICE_COPY_CAMPAIGN = '/campaign/copy_campaign';

// Brand Flow
export const API_BRAND = '/brand';
export const API_GET_BRANDS_OF_USER = '/brand/brands-of-user';
export const API_UPDATE_BRAND_ONBOARDING_STATUS = '/brand/update-onboarding-status';
export const API_GET_BRAND_URL = '/brand/get-brand-url';

// Create Flow
export const API_CREATE_FLOW = 'text-generation';
export const API_GENERATE_IMAGE = '/generate-image/text-to-image';
export const API_FAVORITE = 'favorite/assets';
export const API_PRODUCT_PHOTO = '/product-photo';
export const API_PRODUCT_PHOTOGRAPHY = '/replace-image-background';
export const API_CREATE_IMAGE_POTION = 'brand-magic/image';

// Projects Flow
export const API_PROJECT = 'project';
export const API_PROJECT_DUPLICATE = 'project/duplicate';
export const API_DOWNLOAD_COUNT = 'download-count/increase';

// Sessions
export const API_ACTIVE_SESSION = '/sessions/active_session';
export const API_CREATE_SESSION = '/sessions/create_session';
export const API_UPDATE_SESSION = '/sessions';

// Template
export const API_GET_ORGANIZATION_TEMPLATES = 'template/get_all_organization_templates';
export const API_PRESIGN_TEMPLATE = '/template/presign_template';
export const API_MARK_PROJECT_AS_TEMPLATE = '/template/mark_project_as_template';

// Assets FLow
export const API_UPLOAD_ASSET = '/upload-asset';

// Generate Flow
export const API_GET_GENERATED_IMAGES = 'create-flow/x-edit/image';
export const API_GET_BACKGROUND_REPLACED_IMAGES = 'create-flow/x-edit/backgroundReplaceimage';
export const API_GET_GENERATED_TEXTS = 'create-flow/x-edit/text';

// Unsplash
export const API_QUERY_UNSPLASH = 'unsplash';
export const API_DOWNLOAD_UNSPLASH = 'unsplash/download';

// Social Media
export const API_SCHEDULE_CONTENT_TO_CLOUD_CAMPAIGN = '/cloud-campaign/schedule-content';
export const API_GET_SOCIAL_MEDIA_OF_BRAND_FOR_CLOUD_CAMPAIGN =
    '/cloud-campaign/get-social-meadia-of-brand';
